import {
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    Box,
    useTheme,
    useMediaQuery
} from '@mui/material';
import PropTypes from 'prop-types'

const OurStory = ({ language = 'EN' }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // Language content
    const content = {
        EN: {
            title: "Our Story",
            paragraphs: [
                "The Unicorn Beauty Business Education Platform was founded in 2017. It is the first beauty education platform created for the beauty industry. It only promotes exclusive beauty business management wisdom, tells the stories of beauty entrepreneurs, and does things for beauty industry people. It also hopes to promote the most sincere beauty education platform model that accompanies the growth of beauty entrepreneurs all the way to the market.",
                "Why is it named Unicorn? In China, a unicorn is someone who dominates the market or has the largest market. The founder named it Unicorn because he wanted to let the Southeast Asian market know that Unicorn Beauty Business School will be the only high-end wisdom exchange platform with the most resources and connections to help promote global beauty wisdom. It is a high-end beauty education brand created for the beauty wisdom construction of the Southeast Asian market, ready to welcome the new beauty industry in Southeast Asia that will subvert the next 20 years.",
                "Craftsmanship is the foundation of the beauty industry. This is the basic infrastructure that every beauty industry person must lay. However, the essence of opening a beauty store is to improve the ability to make money through craftsmanship and services. Therefore, beauty industry people must have business thinking, how to manage the store, how to create different marketing channels and marketing methods according to market demand, and at the same time, they can build a team to allow themselves and the beauty store to continue to be replicated. Therefore, any course from Unicorn Beauty Business School will combine beauty education with craftsmanship and beauty management, beauty marketing, and beauty team building to enhance the understanding of beauty industry people."
            ],
            focusTitle: "Our Focus Areas:",
            services: [
                {
                    title: "Education",
                    description: "Business Management, Technical Skills, Online Education",
                    bgImage: "/images/education-bg.jpg",
                    color: theme.palette.primary.main
                },
                {
                    title: "Consultation",
                    description: "Group Coaching, Customized Consultation",
                    bgImage: "/images/consultation-bg.jpg",
                    color: theme.palette.secondary.main
                },
                {
                    title: "Incubation",
                    description: "Joint Ventures using Knowledge/Wisdom",
                    bgImage: "/images/incubation-bg.jpg",
                    color: theme.palette.success.main
                }
            ]
        },
        BM: {
            title: "Cerita Kami",
            paragraphs: [
                "Platform Pendidikan Perniagaan Kecantikan Unicorn diasaskan pada tahun 2017. Ia merupakan platform pendidikan kecantikan pertama yang dicipta untuk industri kecantikan. Ia hanya mempromosikan kebijaksanaan pengurusan perniagaan kecantikan eksklusif, menceritakan kisah usahawan kecantikan, dan melakukan perkara untuk orang industri kecantikan. Ia juga berharap dapat mempromosikan model platform pendidikan kecantikan yang paling ikhlas yang menemani pertumbuhan usahawan kecantikan sehingga ke pasaran.",
                "Mengapa ia dinamakan Unicorn? Di China, unicorn adalah seseorang yang mendominasi pasaran atau mempunyai pasaran terbesar. Pengasas menamakannya Unicorn kerana beliau ingin memberitahu pasaran Asia Tenggara bahawa Sekolah Perniagaan Kecantikan Unicorn akan menjadi satu-satunya platform pertukaran kebijaksanaan tinggi dengan sumber dan sambungan paling banyak untuk membantu mempromosikan kebijaksanaan kecantikan global. Ia adalah jenama pendidikan kecantikan tinggi yang dicipta untuk pembinaan kebijaksanaan kecantikan pasaran Asia Tenggara, bersedia untuk menyambut industri kecantikan baru di Asia Tenggara yang akan mengubah 20 tahun akan datang.",
                "Kemahiran adalah asas industri kecantikan. Ini adalah infrastruktur asas yang mesti diletakkan oleh setiap orang industri kecantikan. Walau bagaimanapun, intipati membuka kedai kecantikan adalah untuk meningkatkan keupayaan menjana wang melalui kemahiran dan perkhidmatan. Oleh itu, orang industri kecantikan mesti mempunyai pemikiran perniagaan, bagaimana menguruskan kedai, bagaimana mencipta saluran pemasaran dan kaedah pemasaran yang berbeza mengikut permintaan pasaran, dan pada masa yang sama, mereka boleh membina pasukan untuk membolehkan diri mereka dan kedai kecantikan terus direplikasi. Oleh itu, mana-mana kursus dari Sekolah Perniagaan Kecantikan Unicorn akan menggabungkan pendidikan kecantikan dengan kemahiran dan pengurusan kecantikan, pemasaran kecantikan, dan pembinaan pasukan kecantikan untuk meningkatkan pemahaman orang industri kecantikan."
            ],
            focusTitle: "Fokus Kami:",
            services: [
                {
                    title: "Pendidikan",
                    description: "Pengurusan Perniagaan, Kemahiran Teknikal, Pendidikan Dalam Talian",
                    bgImage: "/images/education-bg.jpg",
                    color: theme.palette.primary.main
                },
                {
                    title: "Perundingan",
                    description: "Bimbingan Berkumpulan, Perundingan Disesuaikan",
                    bgImage: "/images/consultation-bg.jpg",
                    color: theme.palette.secondary.main
                },
                {
                    title: "Pengeraman",
                    description: "Usahasama menggunakan Pengetahuan/Kebijaksanaan",
                    bgImage: "/images/incubation-bg.jpg",
                    color: theme.palette.success.main
                }
            ]
        },
        CN: {
            title: "我们的故事",
            paragraphs: [
                "独角兽美业商业教育平台成立于2017年。它是第一个为美业行业创建的美业教育平台。它只推广独家美业商业管理智慧，讲述美业企业家的故事，并为美业行业人士做事。它还希望推广最真诚的美业教育平台模式，陪伴美业企业家一路成长到市场。",
                "为什么叫独角兽？在中国，独角兽是主导市场或拥有最大市场的人。创始人将其命名为独角兽，因为他想让东南亚市场知道，独角兽美业商学院将成为唯一拥有最多资源和联系的高端智慧交流平台，以帮助推广全球美业智慧。它是一个为东南亚市场的美业智慧建设而创建的高端美业教育品牌，准备迎接将在未来20年颠覆东南亚的新美业行业。",
                "工艺是美业行业的基础。这是每个美业行业人士必须铺设的基础设施。然而，开美业店的本质是通过工艺和服务提高赚钱能力。因此，美业行业人士必须具备商业思维，如何管理店铺，如何根据市场需求创造不同的营销渠道和营销方法，同时，他们可以建立一个团队，让自己和美业店继续被复制。因此，独角兽美业商学院的任何课程都将美业教育与工艺和美业管理、美业营销和美业团队建设相结合，以增强美业行业人士的理解。"
            ],
            focusTitle: "我们的重点领域:",
            services: [
                {
                    title: "教育",
                    description: "商业管理、技术技能、在线教育",
                    bgImage: "/images/education-bg.jpg",
                    color: theme.palette.primary.main
                },
                {
                    title: "咨询",
                    description: "团体辅导、定制咨询",
                    bgImage: "/images/consultation-bg.jpg",
                    color: theme.palette.secondary.main
                },
                {
                    title: "孵化",
                    description: "利用知识/智慧进行合资",
                    bgImage: "/images/incubation-bg.jpg",
                    color: theme.palette.success.main
                }
            ]
        }
    };

    const currentContent = content[language] || content.EN;

    return (
        <Container id="story" sx={{ py: 8 }}>
            <Typography variant="h2" gutterBottom align="center">
                {currentContent.title}
            </Typography>
            <Grid container spacing={6}>
                <Grid item xs={12} md={6}>
                    {currentContent.paragraphs.map((paragraph, index) => (
                        <Typography key={index} paragraph sx={{ textAlign: 'justify' }}>
                            {paragraph}
                        </Typography>
                    ))}
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant="h4" gutterBottom>
                        {currentContent.focusTitle}
                    </Typography>
                </Grid>
                <Box sx={{
                    px: isMobile ? 2 : 6,
                    py: 6,
                    position: 'relative'
                }}>
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '50%',
                        bgcolor: 'background.paper',
                        zIndex: -1,
                        borderRadius: '0 0 20px 20px'
                    }} />

                    <Grid
                        container
                        spacing={4}
                        sx={{
                            justifyContent: 'center',
                            perspective: '1000px'
                        }}
                    >
                        {currentContent.services.map((service, index) => (
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={4}
                                key={service.title}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    transformStyle: 'preserve-3d',
                                    transition: 'transform 0.5s',
                                    '&:hover': {
                                        transform: isMobile ? 'none' : 'translateY(-10px)'
                                    }
                                }}
                            >
                                <Card
                                    sx={{
                                        width: 300,
                                        height: 300,
                                        position: 'relative',
                                        borderRadius: '16px',
                                        overflow: 'hidden',
                                        boxShadow: 6,
                                        '&:before': {
                                            content: '""',
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backgroundImage: `url(${service.bgImage})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            filter: 'brightness(0.7)',
                                            zIndex: 1
                                        }
                                    }}
                                >
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            zIndex: 2,
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'flex-end',
                                            p: 3,
                                            color: 'white',
                                            background: `linear-gradient(to top, ${service.color}99 0%, transparent 100%)`
                                        }}
                                    >
                                        <Typography
                                            variant="h4"
                                            component="h3"
                                            gutterBottom
                                            sx={{
                                                fontWeight: 'bold',
                                                textShadow: '0 2px 4px rgba(0,0,0,0.5)'
                                            }}
                                        >
                                            {service.title}
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                textShadow: '0 1px 3px rgba(0,0,0,0.5)',
                                                opacity: 0.9
                                            }}
                                        >
                                            {service.description}
                                        </Typography>
                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Grid>
        </Container>
    );
};

OurStory.propTypes = {
    language: PropTypes.oneOf(['EN', 'BM', 'CN'])
};

export default OurStory;